import { useSession } from "../../../SessionContext";
import { useLanguage } from "../../../../context/LanguageContext";
import { ScreenSequence } from "../Sequences";
import { DecoyFriesScreen } from "./DecoyEffectScreen1";
import { DecoyDrinkScreen } from "./DecoyEffectScreen2";
import { Decoy2FriesScreen } from "./DecoyEffectScreen3";
import { Decoy2DrinkScreen } from "./DecoyEffectScreen4";
import { DecoyExplainationScreen } from "./ExplanationScreen";
import { ResultScreen } from "./ResultScreen";
import { ResultScreenRelative } from "./ResultScreenRelative";
import { WellDoneScreen } from "../../../WellDoneScreen";
import { DecoyEffect } from "../../../../translations/experiments/DecoyEffect";

export const DecoyEffectKey = "DecoyEffect";

/**
 * Hook to get the Decoy Effect experiment sequence with translations
 * Uses the language context to provide translated content for title/description
 */
export function useDecoyEffectSequence(): ScreenSequence {
    const { userData } = useSession();
    const { language } = useLanguage();
    const translations = DecoyEffect[language] || DecoyEffect.de;
    const randomizer4 = userData?.randomizer4 || "Bedingung 1";

    return {
        name: translations.title,
        description: translations.description,
        group: "A3",
        screens: [
            randomizer4 === "Bedingung 2"
                ? { component: Decoy2FriesScreen }
                : { component: DecoyFriesScreen },
            randomizer4 === "Bedingung 2"
                ? { component: Decoy2DrinkScreen }
                : { component: DecoyDrinkScreen },
            { component: ResultScreen.component },
            { component: ResultScreenRelative.component },
            { component: DecoyExplainationScreen.component },
            {
                component: WellDoneScreen,
                canContinueDefault: false,
            }
        ],
        resultScreenIndex: 2,
        explanationScreenIndex: 4,
    };
}

// Optional: static export for Sequences.tsx (defaults to German)
const decoyEffectTranslations = DecoyEffect.de;
export const DecoyEffectSequence: ScreenSequence = {
    name: decoyEffectTranslations.title,
    description: decoyEffectTranslations.description,
    group: "A1",
    screens: [
        { component: DecoyFriesScreen },
        { component: DecoyDrinkScreen },
        { component: ResultScreen.component },
        { component: ResultScreenRelative.component },
        { component: DecoyExplainationScreen.component },
        {
            component: WellDoneScreen,
            canContinueDefault: false,
        }
    ],
    resultScreenIndex: 2,
    explanationScreenIndex: 4,
};